<template>
    <div data-cy="container_campaign_detail">
        <div class="max-w-500 mx-auto max-h-screen">
            <TopBarBack data-cy="btn_campaign_back" @onClickBack="clickBack()"></TopBarBack>
            <div class="grid grid-cols-1" v-if="campaign != null" data-cy="container_campaign_content">
                <div class="box-blue pt-2" data-cy="container_campaign_picture">
                    <div class="px-4">
                        <Picture :campaign="campaign"></Picture>
                    </div>
                </div>
                <div class="pt-5 px-4" data-cy="container_campaign_info">
                    <DetailInfo
                        data-cy="component_campaign_detail_info"
                        :campaign="campaign"
                        ref="isFavorite"
                        @clickFav="clickFav()"
                    ></DetailInfo>
                    <DetailAndCondition data-cy="component_campaign_detail_condition" :campaign="campaign"></DetailAndCondition>
                </div>
            </div>
            <div data-cy="container_campaign_redeem_mobile">
                <RedeemButton
                    v-if="campaign != null"
                    data-cy="component_campaign_redeem_button_mobile"
                    class="p-4"
                    :detailController="detailController"
                    @clickRedeem="clickRedeem()"
                ></RedeemButton>
            </div>
        </div>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
//component
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import DetailInfo from '../component/DetailInfo.vue';
import Picture from '../component/Picture.vue';
import DetailAndCondition from '../component/DetailAndCondition.vue';
import RedeemButton from '../component/RedeemButton.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
// import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { FormAddressModel } from '../modal/ShippingAddressModal/model/FormAddressModel';

export default {
    name: "Campaign",
    mixins: [ModalMixin, AuthStatusMixin],
    components: {
        TopBarBack,
        DetailInfo,
        Picture,
        DetailAndCondition,
        RedeemButton,
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,

        };
    },
    created: function() {
        this.initialIsFromLanding();
        this.clearCacheFormAddress();
    },
    activated() {
        if (this.isLoaded) {
            this.initialCampaign();
        }

        // called on initial mount
        // and every time it is re-inserted from the cache
    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: function() {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();

            this.tracking.screenName('campaign_detail');
            this.tracking.event('campaign_detail_privilege', 'view_campaign_detail', campaignId, null);
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
            }
        },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.modal.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                Util.log("campaign", campaign);
                this.campaign = campaign;

                this.redeemController.initial(this.campaign, this.modal);
                this.setRedeemEvent();
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.modal.loadingModal.hide();
            });
        },
        //#endregion setup

        //#region event
        clickRedeem: function() {
            var selectCampaignId = this.detailController.selectedCampaignId;
            var selectedQuantity = this.detailController.selectedQuantity;
            this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
            this.tracking.event('campaign_detail_redeem', 'click_redeem', selectCampaignId, null);
        },
        setRedeemEvent: function() {
            this.redeemController.onShowRedeem = () => {
                this.tracking.screenName('campaign_confirm');
                return true;
            };
            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                this.tracking.event('campaign_detail_confirm_redeem', 'click_confirm_redeem', this.campaign.id, null);
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                this.tracking.event('campaign_detail_confirm_redeem', 'click_cancel_redeem', this.campaign.id, null);
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onConfirmShipping = () => {
                this.tracking.event('campaign_delivery', 'click_confirm_address', null, null);
                return true;
            };
            this.redeemController.onCancelShipping = () => {
                this.tracking.event('campaign_delivery', 'click_edit_address', null, null);
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.modal.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = () => {
                this.initialCampaign();
                this.modal.loadingModal.hide();
                this.clearCacheFormAddress();
                return true;
            };
            this.redeemController.onRedeemError = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.modal.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onCloseDelivery = () => {
                this.tracking.event('campaign_delivery', 'click_closed', null, null);
                return true;
            };
            this.redeemController.onViewDelivery = () => {
                this.tracking.event('campaign_delivery', 'click_my_rewards', null, null);
                return true;
            };
        },
        //#endregion event

        onLoadedCampaign: function() {
            this.isLoaded = true;
        },
        clickBack: function() {
            this.$router.back();
        },
        clickFav: function() {
            this.tracking.event('campaign_detail_favorite', 'click_favorite', this.campaign.id, null);

            this.detailController.clickFavourite().then((campaign) => {
                Util.log("campaign", campaign);
                this.$refs['isFavorite'].updateFavorite(campaign.isFavourite);
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.modal.loadingModal.hide();
            });
        },

        clearCacheFormAddress: function () {
            let formAddress = new FormAddressModel()
            formAddress.removeCache()
        },
    },
}
</script>
 <style lang="scss" scoped>
.box-blue{
    background: linear-gradient(
        to bottom,
        #002850 0%,
        #002850 38%,
        white 38%,
        white 100%
    );
}
.btn-shadow {
    box-shadow: 0 -4px 10px 0 rgba(33, 64, 166, 0.15);;
}
</style>
